import { TRootState } from '../reducers';
import { ILastClickedLink } from '../reducers/types';

export const selectLastClickedLink = (state: TRootState): ILastClickedLink | null =>
  state.lastClickedLink.lastClickedLink;
